<script>
    import { fly } from 'svelte/transition'
    import { closeModal } from "svelte-modals";

    export let isOpen;
    export let title;
    export let message;
    export let onConfirm;
    export let confirmButtonClass;
    export let containerClass = "w-10/12 md:w-96"
</script>

{#if isOpen}
    <div
        class="custom-modal delete-button shadow-md flex flex-col gap-2 justify-between {containerClass}"
        transition:fly={{ y: -100 }}
        on:introstart
        on:outroend
    >
        <div class="flex flex-col gap-1">
            <div class="text-3xl font-bold red-si">{title}</div>
            <div class="text-xl">{message}</div>
        </div>

        <div class="flex justify-end gap-2">
            <button class="bg-lightBlue-500 {confirmButtonClass} p-2 px-4 font-semibold text-white hover:shadow-lg focus:outline-none" on:click={onConfirm}>Conferma</button>
            <button class="border-0 bg-blueGray-600 p-2 px-4 font-semibold text-white hover:shadow-lg focus:outline-none" on:click={closeModal}>Annulla</button>
        </div>
    </div>
{/if}